import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import { FormElement, Label } from '@dashboard/components/Form';
import { Select } from '@dashboard/components/Formik';
import FormError from '@dashboard/components/Formik/components/FormError';

function getShouldSelectOption(comparison) {
  return comparison === 'IS' || comparison === 'IS_NOT';
}

export default function ShowHideLogicField({ variantId, variant, product }) {
  const [field, , helpers] = useField(`showHideLogic`);

  const { setValue } = helpers;

  const { variants } = product;
  const [selectedVariantId, setSelectedVariantId] = useState(
    variant.showHideLogic?.element?.elementId || null,
  );
  const [selectedVariantOptionId, setSelectedVariantOptionId] = useState(
    variant.showHideLogic?.value || null,
  );

  const selectedVariant = variants.find(
    v => v._id === selectedVariantId && v.selectionType !== 'quantity',
  );
  const selectedVariantOption = selectedVariant?.options.find(
    o => o._id === selectedVariantOptionId,
  );

  const shouldSelectOption = selectedVariant && getShouldSelectOption(field.value.comparison);

  const availableVariants = variants
    .filter(v => v._id !== variantId)
    .filter(v => v.selectionType !== 'quantity');

  useEffect(() => {
    if (selectedVariantId) {
      const selectedVariant = variants.find(
        v => v._id === selectedVariantId && v.selectionType !== 'quantity',
      );

      if (!selectedVariant) {
        return;
      }

      setValue({
        ...field.value,
        element: {
          elementId: selectedVariant._id,
          elementType: 'variant',
          elementTitle: selectedVariant.name,
        },
      });
    }
  }, [selectedVariantId]);

  useEffect(() => {
    if (selectedVariantOptionId) {
      setValue({
        ...field.value,
        value: selectedVariantOptionId,
      });
    }
  }, [selectedVariantOptionId]);

  return (
    <div className="ml-6 !space-y-2 !mb-2 !mt-2">
      <FormElement>
        <div className="flex items-baseline space-x-2">
          <Label htmlFor={`variants.${variantId}.showHideLogic.element.elementId`} className="w-16">
            Variant
          </Label>

          <Select
            id={`variants.${variantId}.showHideLogic.element.elementId`}
            name="showHideLogic.element"
            onChange={e => {
              setSelectedVariantId(e.target.value);
            }}
            value={selectedVariant?._id}
          >
            <option value="" default>
              Select variant
            </option>
            {availableVariants.map(variant => (
              <option key={variant._id} value={variant._id}>
                {variant.name}
              </option>
            ))}
          </Select>
        </div>

        <FormError name="showHideLogic.element.elementId" />
        <FormError name="showHideLogic.element.elementName" />
        <FormError name="showHideLogic.element.elementType" />
      </FormElement>

      <FormElement className="">
        <div className="flex items-baseline gap-x-2">
          <div className="w-16" />

          <Select
            id={`variants.${variant._id}.showHideLogic.comparison`}
            name="showHideLogic.comparison"
            className="w-32"
          >
            <option value="" default>
              Select condition
            </option>
            <option value="IS">is</option>
            <option value="IS_NOT">is not</option>
            <option value="IS_EMPTY">is empty</option>
            <option value="IS_NOT_EMPTY">is not empty</option>
          </Select>
        </div>
        <FormError name="showHideLogic.comparison" />
      </FormElement>

      <FormElement>
        {shouldSelectOption && (
          <div className="flex items-baseline gap-x-2">
            <Label htmlFor={`variants.${variantId}.showHideLogic.value`} className="w-16">
              Option
            </Label>

            <Select
              id={`variants.${variantId}.showHideLogic.value`}
              name="showHideLogic.value"
              className="w-32"
              onChange={e => {
                setSelectedVariantOptionId(e.target.value);
              }}
              value={selectedVariantOption?._id}
            >
              <option value="" default>
                Select option
              </option>

              {selectedVariant.options.map(option => (
                <option key={option._id} value={option._id}>
                  {option.name}
                </option>
              ))}
            </Select>
          </div>
        )}

        <FormError name="showHideLogic.value" />
      </FormElement>
    </div>
  );
}
